<template>
  <div class="workflow-process">
    <process-node :key="node.id" :node="node" v-for="node in nodes"/>
  </div>
</template>

<script>
  import ProcessNode from "./process-node";

  export default {
    name: "process",
    props: ["nodes"],
    components: {ProcessNode}
  }
</script>

<style scoped>

</style>
